import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const uspowereldConfig: TSPConfig = {
  key: 'uspowereld',
  name: 'USPowerELD',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please input your USPowerELD username, password, and API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default uspowereldConfig;
